import './SimpleSlider.scss'
import cn from 'classnames'

export default function SimpleSlider({
  className,
  thumbClassName,
  trackClassName,
  sliderRef,
  sliderValue
}) {
  return (
    <div ref={sliderRef} className={cn('simple-slider', className)}>
      <div
        className={cn('simple-slider-track', trackClassName)}
        style={{
          width: `${sliderValue}%`
        }}
      ></div>
      <span
        className={cn('simple-slider-thumb', thumbClassName)}
        style={{
          left: `${sliderValue}%`
        }}
      ></span>
    </div>
  )
}
